import { FC, ReactNode } from "react";
import { useTheme, Theme } from "@emotion/react";
import { CheckSmall } from "src/icons/CheckSmall";
import { CheckCircleDrawIcon } from "src/icons/CheckCircleDrawIcon";
import {
  ChoiceCardButton,
  ChoiceCardIcon,
  ChoiceCardSuccess,
} from "./ChoiceCard.styled";

interface ChoiceCardProps {
  label: ReactNode;
  selected?: boolean;
  onClick?: () => void;
  locked?: boolean;
  compact?: boolean;
}

/**
 * A single-select option card.
 */
const ChoiceCard: FC<ChoiceCardProps> = ({
  label,
  selected = false,
  onClick,
  locked = false,
  compact = false,
}) => (
  <ChoiceCardButton
    $compact={compact}
    $selected={selected}
    $locked={locked}
    type="button"
    aria-pressed={selected}
    aria-disabled={locked || undefined}
    onClick={locked ? undefined : onClick}
  >
    {label}
    {selected && (
      <ChoiceCardIcon>
        <CheckSmall />
      </ChoiceCardIcon>
    )}
  </ChoiceCardButton>
);

const ChoiceCardConfirmation: FC<{ label: ReactNode; animate?: boolean }> = ({
  label,
  animate = false,
}) => {
  const theme: Theme = useTheme();

  return (
    <ChoiceCardSuccess role="status" data-animate={animate}>
      <ChoiceCardIcon>
        <CheckCircleDrawIcon color={theme.colors.semantic.green} />
      </ChoiceCardIcon>
      {label}
    </ChoiceCardSuccess>
  );
};

export { ChoiceCard, ChoiceCardConfirmation };
